import { render, staticRenderFns } from "./boardMemberListView.vue?vue&type=template&id=d4bd34d8&scoped=true"
import script from "./boardMemberListView.vue?vue&type=script&lang=js"
export * from "./boardMemberListView.vue?vue&type=script&lang=js"
import style0 from "./boardMemberListView.vue?vue&type=style&index=0&id=d4bd34d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bd34d8",
  null
  
)

export default component.exports